import React from 'react'
import { defaultProps, withProps } from 'recompose'
import { Link, useNavigate } from 'react-router-dom'

import {
  Button as CoreButton,
  Intent,
  Menu as CoreMenu,
  MenuItem as CoreMenuItem,
  Popover as CorePopover,
  Icon,
  AnchorButton as CoreAnchorButton,
  ButtonGroup as CoreButtonGroup,
  Classes,
  Position
} from '@blueprintjs/core'

export const ButtonGroup = defaultProps({
  alignText: 'center'
})(CoreButtonGroup)

export const Button = defaultProps({
  style: {
    marginLeft: 10,
    whiteSpace: 'nowrap'
  }
})(CoreButton)

export const AnchorButton = defaultProps({
  style: {
    marginLeft: 10,
    whiteSpace: 'nowrap'
  }
})(CoreAnchorButton)

export const ButtonLink = ({ disabled, to = '', state = {}, target, ...props }) => {
  if (disabled) {
    return <Button disabled {...props} />
  }
  return (
    <Link to={to} state={state} target={target}>
      <Button {...props} />
    </Link>
  )
}

export const ButtonMenu = ({ menuIcon, rightMenuIcon, menuText, buttonStyle, disabled, ...props }) => (
  <CorePopover disabled={disabled} content={<CoreMenu {...props} />}>
    <Button disabled={disabled} style={buttonStyle} icon={menuIcon} text={menuText} rightIcon={rightMenuIcon}/>
  </CorePopover>
)

export const NavButton = (props) => {
  return (
    <CoreButton minimal {...props} />
  )
}

export const NavButtonLink = ({ to = "/", disabled, target, minimal = true, ...props }) => {
  if (disabled) {
    return <Button minimal={minimal} disabled {...props} />
  }
  return target
    ? (<a href={to} target={target}>
      <NavButton minimal={minimal} {...props} />
    </a>
    )
    : (
      <Link to={to}>
        <NavButton minimal={minimal} {...props} />
      </Link>
    )
}

export const NavButtonMenu = ({ menuIcon, menuText, popoverProps, ...props }) =>
  <CorePopover
    position={Position.BOTTOM} {...popoverProps}
    content={<CoreMenu {...props} />}
  >
    <NavButton icon={menuIcon} style={{ textAlign: 'center' }} >
      {menuText}
      <Icon style={{ marginLeft: '3px', marginRight: '3px' }} icon='caret-down' />
    </NavButton>
  </CorePopover>

export const NavButtonMenuItem = ({ ...props }) => (
  <CoreMenuItem {...props} />
)

export const NavButtonLinkMenuItem = ({ to = '/', state = {}, inNewTab, ...props }) => {
  const navigate = useNavigate()
  return inNewTab
    ? <Link to={to} target='_blank'>
      <NavButtonMenuItem {...props} />
    </Link>
    : <NavButtonMenuItem onClick={() => navigate(to, { state })} {...props} />
}

export const NavRawButtonLinkMenuItem = ({ disabled, to = '/', target, ...props }) => {
  if (disabled) {
    return <Button disabled {...props} />
  }
  return (
    <Link className={Classes.POPOVER_DISMISS} to={to} target={target}>
      <NavButtonMenuItem {...props} />
    </Link>
  )
}

const mobileStyling = { padding: '.5em 1.3em', margin: '0 .25em' }
const regularStyling = { margin: '0 .25em' }

export const AddButton = withProps(({ isMobile, ...props }) => ({
  icon: 'add',
  intent: Intent.PRIMARY,
  text: !isMobile && 'Add',
  style: isMobile ? mobileStyling : regularStyling,
  ...props
}))(Button)

export const SaveButton = withProps(({ isMobile, ...props }) => ({
  icon: 'saved',
  intent: Intent.SUCCESS,
  text: !isMobile && 'Save',
  style: isMobile ? mobileStyling : regularStyling,
  type: 'submit',
  ...props
}))(Button)

export const DangerButton = withProps({
  intent: Intent.DANGER
})(Button)

export const DeleteButton = withProps(({ isMobile, textOverride = '', ...props }) => ({
  icon: 'trash',
  intent: Intent.WARNING,
  text: isMobile
    ? ''
    : textOverride || 'Delete',
  style: isMobile ? mobileStyling : regularStyling,
  ...props
}))(Button)

export const CancelButton = withProps(({ isMobile, ...props }) => ({
  icon: 'disable',
  intent: Intent.DANGER,
  text: !isMobile && 'Cancel',
  style: isMobile ? mobileStyling : regularStyling,
  type: 'reset',
  ...props
}))(Button)

export const ResetButton = withProps(({ isMobile, ...props }) => ({
  icon: 'disable',
  intent: Intent.DANGER,
  text: !isMobile && 'Cancel',
  style: isMobile ? mobileStyling : regularStyling,
  ...props
}))(Button)

export const IconLink = ({ icon, to = '/', target, iconSize = 16, style = {} }) => {
  return target
    ? <a href={to} target={target}>
      <Icon icon={icon} iconSize={iconSize} style={style} />
    </a>
    : <Link to={to}>
      <Icon icon={icon} iconSize={iconSize} style={style} />
    </Link>
}